// extracted by mini-css-extract-plugin
module.exports = {"faqList":"FaqList-module--faqList--2r2G-","faqItem":"FaqList-module--faqItem--2BZKs","faqItemQuestion":"FaqList-module--faqItemQuestion--22uLI"};